import { render } from "./FpExplanation.vue?vue&type=template&id=0d5fcd9f"
import script from "./FpExplanation.vue?vue&type=script&lang=js"
export * from "./FpExplanation.vue?vue&type=script&lang=js"

import _style_0 from "./FpExplanation.vue?vue&type=style&index=0&id=0d5fcd9f&inline&lang=css"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__